import MessageFormatOptionState from '../store/schema/MessageFormatOptionState';
import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';

export interface DiscardMessageFormatOptionState {
    optionState: MessageFormatOptionState;
}

export default select<DiscardMessageFormatOptionState>({
    optionState: () => store,
})(
    action('discardMessageFormatOption')(function discardMessageFormatOption(
        state?: DiscardMessageFormatOptionState
    ) {
        let { optionState } = state;
        optionState.showBcc = null;
        optionState.showFrom = null;
        optionState.composeFormat = null;
        optionState.fontFamily = null;
        optionState.fontSize = null;
        optionState.isFontBold = null;
        optionState.isFontItalic = null;
        optionState.isFontUnderline = null;
        optionState.fontColor = null;
        optionState.isColorMenuShown = false;
    })
);
